import React from 'react'
import injectSheet from 'react-jss'
import styles from './bone.styles.js'
import classNames from 'classnames'
import PropTypes from 'prop-types'

const Bone = ({ classes, style, className }) => (
  <span className={classNames(classes.bone, className)} style={style} />
)

Bone.propTypes = {
  /** Restyle bone with inline styles */
  style: PropTypes.object,
  /** Restyle bone by providing additional className */
  className: PropTypes.string
}

export default injectSheet(styles)(Bone)
